import React from 'react';
import './App.css';
import CollegeWizard from './components/CollegeWizard';

export default function App() {
  return <CollegeWizard />;
}
